module.exports = __webpack_public_path__ + "img/point-mockup.7558cf00.png";